import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "link-btn",
    href: _ctx.href,
    style: _normalizeStyle(_ctx.styleObject),
    target: "_blank"
  }, _toDisplayString(_ctx.text), 13, _hoisted_1))
}